import { Component, effect, input, ViewChild } from '@angular/core';
import { QaiDialogComponent, QaiIconComponent } from '@qai/ui';

@Component({
  selector: 'app-camera-inactive-warning',
  standalone: true,
  imports: [QaiDialogComponent, QaiIconComponent],
  templateUrl: './camera-inactive-warning.component.html',
  styleUrls: ['./camera-inactive-warning.component.scss'],
})
export class CameraInactiveWarningComponent {
  isVisible = input(false);

  @ViewChild('dialog') dialogRef: QaiDialogComponent | undefined;

  readonly title = 'Camera Inactive';
  readonly warningText = 'Your camera has become inactive. Please restore your camera connection to continue the certification.';
  readonly instructionText = 'The certification will resume automatically when your camera is restored.';

  constructor() {
    effect(() => {
      if (this.isVisible()) {
        this.dialogRef?.showModal();
      } else {
        this.dialogRef?.close();
      }
    });
  }
}
